import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import Sidebar from '../../components/sidebar/sidebar';
import './logs.css';
import Topbar from '../../components/topbar/topbar';
import Card from 'react-bootstrap/Card';
import { columns } from './columns.jsx';
import MUIDataTable from 'mui-datatables';
import Fontawesome from '../../components/fontawesome/fontawesome';
import { Prefix } from '../../services/prefix';
import { useFetch } from '../../components/hooks/useFetch';
import Loading from '../../components/loader/loading';
import api from '../../services/api';
import Swal from 'sweetalert2';
import CustomSearchRender from '../../components/customSearchRender/CustomSearchRender';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomFooter from '../../components/CustomFooter/CustomFooter';
import Table from 'react-bootstrap/Table';
import {
  CardSt,
  CardHeaderSt,
  IconTitleSt,
  TitleSt,
  TextTitleSt,
  SmallTitleSt,
} from '../../style/globalStyle';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { GetMuiTheme } from '../../components/muiTheme/muiTheme';

export const UserLog = () => {
  const [loader, setLoader] = useState();
  const [data, setData] =
    useState(); /*Armazena novo array contendo todos os itens exceto os removidos */ /*copiar*/
  const [pagina, setPagina] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [search, setSearch] = useState('');

  let pageExact = parseInt(pagina) + parseInt(1);

  const logList = useFetch(
    Prefix.replace(/[\\"]/g, '') +
      '/logs?per_page=' +
      perPage +
      '&page=' +
      pageExact +
      '&search=' +
      search,
  );

  const dataList = logList.data?.models.data;

  const options = {
    filterType: 'dropdown',
    draggableColumns: {
      enabled: true,
    },
    filter: false,
    serverSide: true,
    onTableChange: (action, tableState) => {
      setPagina(tableState.page);
      setPerPage(tableState.rowsPerPage);
    },
    onSearchChange: (searchText) => {
      setSearch(!searchText ? '' : searchText);
    },
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <CustomSearchRender
          placeholderSearch="Pesquisar Histórico"
          searchText={searchText}
          onSearch={handleSearch}
          onHide={hideSearch}
          options={options}
        />
      );
    },
    filter: false,
    page: pagina,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    rowsPerPage: perPage,
    rowsPerPageOptions: [15, 30, 100],
    isRowExpandable: (dataIndex, expandedRows) => {
      //if (dataIndex === 3 || dataIndex === 4) return false; Desativa a 3º e 4º linha
      if (
        expandedRows.data.length > 4 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Row>
              <Col className="text-center">
                <h4>Dados do Histórico</h4>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Data:</th>
                      <th>Usuário:</th>
                      <th>Ação:</th>
                      <th>Local:</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{rowData[2]}</td>
                      <td>{rowData[3]}</td>
                      <td>{rowData[5]}</td>
                      <td>{rowData[4]}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </TableCell>
        </TableRow>
      );
    },
    onRowsDelete: (rowsDeleted, newData) => {
      setData(newData);
      HandleDelete(rowsDeleted.data);
    },

    searchPlaceholder: 'Pesquise um histórico',
    selectableRows: 'none',
    searchOpen: true,

    textLabels: {
      body: {
        noMatch: 'Desculpe, não encontramos históricos!',
        toolTip: 'Sort',
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: 'Avançar',
        previous: 'Voltar',
        rowsPerPage: 'Linhas por página:',
        displayRows: 'de',
      },

      toolbar: {
        search: 'Pesquisar',
        downloadCsv: 'Baixar CSV',
        print: 'Imprimir',
        viewColumns: 'Ver Colunas',
        filterTable: 'Filtrar tabela',
      },
      filter: {
        all: 'Tudo',
        title: 'FILTROS',
        reset: 'RESETAR',
      },
      viewColumns: {
        title: 'Exibir colunas',
        titleAria: 'Exibir/Ocultar colunas da tabela',
      },
      selectedRows: {
        text: 'Coluna(s) selecionada(s)',
        delete: 'Excluir',
        deleteAria: 'Excluir linhas selecionadas',
      },
    },

    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels,
    ) => {
      let numberPages = dataList?.last_page;
      let rowsPerPageOptions = [15, 30, 100];
      return (
        <CustomFooter
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          numberPages={numberPages}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      );
    },
  };

  /*Função faz remover item por item usando rota delete - trocar apenas customerCity.data?.cities*/
  function HandleDelete(e) {
    setLoader(<Loading />);
    let idArr = [];
    e.map((del) => {
      idArr.push(dataList.filter((filtro, index) => index == del.index)[0].id);
    });

    idArr.map((idDel) =>
      api
        .post(Prefix.replace(/[\\"]/g, '') + '/logs/' + idDel)
        .then((response) => {
          Swal.fire({
            icon: 'success',
            title: 'Uow!',
            text: response.data.message,
            confirmButtonText: 'Fechar',
          });
          setLoader();
          logList.mutate();
        })
        .catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err.response.data.message,
            confirmButtonText: 'Tentar novamente',
          });
          setLoader();
        }),
    );
  }

  console.clear();

  return (
    <div className="wrapper d-flex align-items-stretch">
      <Sidebar />
      <div id="content">
        <Topbar />
        <div className="content_all">
          <CardSt>
            <CardHeaderSt className="d-flex justify-content-between">
              <TitleSt>
                <IconTitleSt
                  style={{ width: '36px' }}
                  src="../../../media/icons-pages/log-page.svg"
                />
                <TextTitleSt>
                  Histórico de Usuários{' '}
                  <SmallTitleSt>Gestão de Históricos de Usuários</SmallTitleSt>
                </TextTitleSt>
              </TitleSt>
            </CardHeaderSt>
            <CardSt.Body as="div">
              <CardSt.Text as="div">
                <MuiThemeProvider theme={GetMuiTheme()}>
                  <MUIDataTable
                    data={dataList}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </CardSt.Text>
            </CardSt.Body>
          </CardSt>
        </div>
      </div>
    </div>
  );
};

export default UserLog;
